<ng-container *mobxAutorun>
  <ng-container *ngIf="shouldDisplay">
    <!-- Label -->
    <span *ngIf="label" class="label">{{ label }}</span>
    <lf-help-tooltip *ngIf="helpMessage" [help]="helpMessage"></lf-help-tooltip>

    <!-- Required icon -->
    <lf-icon
      class="is-required"
      icon="asterisk"
      *ngIf="showIsRequired && !isReadOnly"
    ></lf-icon>

    <!-- Pending validation -->
    <div
      class="status pending"
      *ngIf="relativeStorage.shouldShowPending() || optionsStatus === 'pending'"
    ></div>
    <!-- Rejected validation -->
    <div
      class="status rejected"
      *ngIf="
        relativeStorage.shouldShowRejected() || optionsStatus === 'rejected'
      "
      (click)="relativeStorage.recomputeStateProperties()"
    >
      <lf-tooltip [help]="retryValidateText">
        <lf-icon icon="warning"></lf-icon>
      </lf-tooltip>
    </div>

    <!-- (Debug) value state -->
    <lf-value-state [path]="path"></lf-value-state>

    <!-- Input group -->
    <div
      class="input-group input-group-sm"
      [class.is-warning]="relativeStorage.shouldShowWarning()"
      [class.is-invalid]="relativeStorage.shouldShowError()"
    >
      <!-- Code -->
      <div *ngIf="code" class="input-group-prepend">
        <div class="input-group-text">{{ code }}</div>
      </div>

      <!-- Select element -->
      <!--
        Note that selects don't support `readonly`, so we use the `disabled`
        attribute; we add an `is-readonly` class to style it differently
      -->
      <select
        #focusTarget
        class="form-control form-control-sm custom-select"
        [class.is-warning]="relativeStorage.shouldShowWarning()"
        [class.is-invalid]="relativeStorage.shouldShowError()"
        [class.is-readonly]="isReadOnly"
        [name]="path"
        [disabled]="isReadOnly"
        (change)="_onSelectChange($event)"
        (focus)="_onFocus($event)"
        (blur)="_onBlur($event)"
      >
        <!-- Default option -->
        <option
          [selected]="selectedOptionIndex === -1"
          disabled
          hidden
        ></option>

        <!-- Disabled option for when there are no options -->
        <option *ngIf="options.length === 0" disabled>
          {{ noOptionsText }}
        </option>

        <!-- User defined options -->
        <option
          *ngFor="let option of options; let i = index"
          [value]="i"
          [selected]="selectedOptionIndex === i"
          [disabled]="option.isDisabled"
        >
          <!-- Option code -->
          <ng-container *ngIf="option.code">{{ option.code }}.</ng-container>

          <!-- Option label -->
          {{ option.label }}
        </option>
      </select>
    </div>

    <!-- Legend -->
    <div *ngIf="legend" class="legend">{{ legend }}</div>
  </ng-container>
</ng-container>
